import { render, staticRenderFns } from "./dingdan_d.vue?vue&type=template&id=05802bf1&scoped=true"
import script from "./dingdan_d.vue?vue&type=script&lang=js"
export * from "./dingdan_d.vue?vue&type=script&lang=js"
import style0 from "./dingdan_d.vue?vue&type=style&index=0&id=05802bf1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05802bf1",
  null
  
)

export default component.exports